(function($) {

	$(document).on('mouseup', function(e) {
		const widget = $('.toggle-opening-hours');

		if ( widget.hasClass('open') && !widget.is(e.target) && widget.has(e.target).length === 0) {
			widget.removeClass('open');
			$('.nav-primary-toggle').removeClass('open');
			$('body').removeClass('overlay-active');
		}
	});

	$('.toggle-opening-hours').on('click', function() {
		$(this).toggleClass('open');
		$('.nav-primary').removeClass('open');
		$('.nav-primary-toggle').removeClass('open');
		$('body').removeClass('overlay-active');
	});


})(jQuery);